"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "wf-component wf-options" };
const _hoisted_2 = {
    key: 0,
    class: "nofloat wf-component-title"
};
const _hoisted_3 = { class: "underground-tokens" };
const _hoisted_4 = ["name", "value"];
const _hoisted_5 = {
    key: 1,
    class: "nofloat"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_underground_token = (0, vue_1.resolveComponent)("underground-token");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.showtitle === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createElementVNode)("div", _hoisted_3, [
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerinput.tokens, (token, idx) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", { key: idx }, [
                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                        type: "checkbox",
                        name: String(idx),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selected) = $event)),
                        value: idx
                    }, null, 8, _hoisted_4), [
                        [vue_1.vModelCheckbox, _ctx.selected]
                    ]),
                    ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_underground_token, {
                        token: token,
                        key: idx,
                        location: "tag-count"
                    }, null, 8, ["token"])),
                    _cache[1] || (_cache[1] = (0, vue_1.createElementVNode)("br", null, null, -1))
                ]));
            }), 128))
        ]),
        (_ctx.showsave === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [
                (0, vue_1.createVNode)(_component_AppButton, {
                    onClick: _ctx.saveData,
                    title: _ctx.playerinput.buttonLabel
                }, null, 8, ["onClick", "title"])
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
